import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "./firebase";
import { format, fromUnixTime, parse } from 'date-fns';
import { useEffect, useState } from "react";
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';

export function timeConvert(n) {
  const num = n;
  const hours = (num / 60);
  const rhours = Math.floor(hours);
  const minutes = (hours - rhours) * 60;
  const rminutes = Math.round(minutes);
  return (rhours ? rhours + "h" : "") + " " + (rminutes ? rminutes + "m" : "");
}


export const getCalendarOverwrites = async (location, showOnlyPastToday = false) => {
  let col;
  if (showOnlyPastToday) {
    col = query(collection(db, `locations/${location}/calendarOverwrites`), where('date', '>=', format(new Date(), 'yyyy-MM-dd')))
  } else {
    col = collection(db, `locations/${location}/calendarOverwrites`);
  }

  const snapshot = await getDocs(col);
  const list = snapshot.docs.map(doc => doc.data());
  return list;
}

export const currencyFormatter = (value) => {
  return value.toLocaleString('en-AU', {
    style: 'currency',
    currency: 'AUD',
  })
}

export const getTimeZones = () => {
  return Intl.supportedValuesOf("timeZone");
}

export const getAustraliaTimeZones = () => {
  return getTimeZones().filter(timeZone => timeZone.includes('Australia'))
}

export const getUserTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export const convertTimeZone = (date, toTimeZone, fromTimeZone) => {
  // Convert input to Date if it's a string
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  // First convert to UTC from source timezone
  const utcDate = zonedTimeToUtc(dateObj, fromTimeZone ?? Intl.DateTimeFormat().resolvedOptions().timeZone);
  
  // Then convert UTC to target timezone
  return utcToZonedTime(utcDate, toTimeZone);
}


export const parseDateAndTime = (startDate, selectedTime, timeZone) => {
  // If no timeZone is provided, use the user's local timeZone
  return zonedTimeToUtc(parse(startDate.format('YYYY-MM-DD') + ' ' + selectedTime, 'yyyy-MM-dd HH:mm', startDate.toDate()), timeZone ??  Intl.DateTimeFormat().resolvedOptions().timeZone)
}

export const timeToSeconds = (time) => {
  return parse(time, 'HH:mm', new Date()).getTime();
}

// Format seconds into minutes:seconds using date-fns
export const formatTime = (seconds) => {
  const date = fromUnixTime(seconds); // Convert seconds to a date object
  return format(date, 'mm:ss'); // Format as minutes:seconds
}

export const useCountDown = (onEnd) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (count <= 0) return;

    const interval = setTimeout(() => {
      if(count > 0) {
        setCount(prevCount => prevCount - 1);
        if(count === 1) {
          // Call onEnd when count is 1
          onEnd();
        }
      }
    }, 1000);

    return () => clearTimeout(interval);
  }, [count]);


  return {count, setCount};
}
